import { useModalMeta } from "@/shared/atoms/useModal";
import Modal, { ModalProps } from "../Modal/Modal";
import ModalTitle from "../Modal/ModalTitle";
import useDiscountCodesGeneratorQuery from "@/shared/queries/discounts/useDiscountCodesGeneratorQuery";
import { useEffect, useState } from "react";
import Spinner from "../Spinner/Spinner";
import Select from "../Select/Select";
import { useTranslation } from "react-i18next";
import Button from "../Button/Button";
import useReviewHook from "@/shared/hooks/useReviewHook";
import { GeneratorTypes } from "@/shared/utils/enum";

const ReviewGeneratorSelectionModal = ({ ...props }: ModalProps) => {
  const { t } = useTranslation("", { keyPrefix: "review_page" });
  const [{ branchId, reviewId }] = useModalMeta();
  const [id, setId] = useState(null);

  const { getDiscountCode } = useReviewHook({
    branchId: branchId,
    reviewId: reviewId,
    generatorId: id,
  });
  const { data, isPending, isSuccess } = useDiscountCodesGeneratorQuery({
    type: GeneratorTypes.REVIEW,
  });

  const handleCreate = () => {
    getDiscountCode.refetch().then(() => props.onExit());
  };

  return (
    <Modal fullHeight width={{ _: "90%", md: "40%" }} {...props}>
      <ModalTitle mb="2rem" p="0">
        {t("generatorModalTitle")}
      </ModalTitle>

      {isPending ? (
        <div className="mt-[2rem]">
          <Spinner />
        </div>
      ) : isPending === false && isSuccess ? (
        <>
          <Select
            onChange={(v) => setId(v.item_id)}
            value={data?.find((d) => d.item_id === id)}
            options={data ?? []}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.value}
          />

          <div className="mt-8 flex justify-end">
            <Button
              isPending={getDiscountCode.isLoading}
              isDisabled={id === null}
              onClick={handleCreate}
            >
              {t("create")}
            </Button>
          </div>
        </>
      ) : null}
    </Modal>
  );
};

export default ReviewGeneratorSelectionModal;
